import { IDonViTinh } from "../../model/respone/category/IDonViTinh"
import { apiClient } from "../apiClient"

export const DON_VI_TINH_API_RESOURCE = "dvt"
export const donViTinhApi = {
    SelectAll: () => apiClient.get(`${DON_VI_TINH_API_RESOURCE}`),
    Insert: (payload: IDonViTinh) => apiClient.post(`${DON_VI_TINH_API_RESOURCE}`,payload),
    Update: (payload: IDonViTinh) => apiClient.put(`${DON_VI_TINH_API_RESOURCE}`,payload),
    Delete: (id: number) => apiClient.delete(`${DON_VI_TINH_API_RESOURCE}/${id}`),
}